<template>
  <v-app>
    <v-btn
      icon
      @click.stop="isNavigationExpanded = !isNavigationExpanded"
      class="arrow-button"
      :class="isNavigationExpanded ? 'arrow-button-right' : 'arrow-button-left'"
      v-if="isUserLoggedin"
    >
      <v-icon v-if="!isNavigationExpanded">mdi-chevron-left</v-icon>
      <v-icon v-else>mdi-chevron-right</v-icon>
    </v-btn>
    <the-layout-drawer
      v-if="isUserLoggedin"
      @mini="onNavigationExpand"
      :miniValue="isNavigationExpanded"
    />
    <the-layout-toolbar
      v-if="isUserLoggedin"
      :class="
        isUserLoggedin
          ? isNavigationExpanded
            ? 'secured-mini-header'
            : 'secured-expanded-header'
          : ''
      "
    />
    <the-layout-footer />
    <v-main
      :class="
        isUserLoggedin
          ? isNavigationExpanded
            ? 'v-main-secured-mini'
            : 'v-main-secured-expanded'
          : ''
      "
    >
      <router-view :key="$route.fullPath" />
    </v-main>
  </v-app>
</template>

<script>
import TheLayoutDrawer from "./views/layout/TheLayoutDrawer.vue";
import TheLayoutToolbar from "./views/layout/TheLayoutToolbar.vue";
// import TheLayoutContent from './views/layout/TheLayoutContent.vue';
import TheLayoutFooter from "./views/layout/TheLayoutFooter.vue";
// import config from "../src/config";
import store from "../src/store";
// import tokenAuthService from "../src/api/tokenAuthenticationService";
// import router from "../src/router";
export default {
  name: "App",
  components: {
    TheLayoutDrawer,
    TheLayoutToolbar,
    // TheLayoutContent,
    TheLayoutFooter
  },

  data() {
    return {
      isUserLoggedin: false,
      isNavigationExpanded: true
    };
  },
  methods: {
    // setAuthTimers() {
    //   this.refreshInterval = setInterval(() => {
    //     //console.log(config.authTokenInterval);
    //     this.callTokenUpdate();
    //   }, parseInt(config.AUTH_TOKEN_INTERVAL));
    // },
    // callTokenUpdate() {
    //   var refershObject = {
    //     grant_type: "refresh_token",
    //     refresh_token: store.getters.refreshToken,
    //     username: store.getters.user
    //   };
    //   tokenAuthService.getAccessTokenByRefreshToken(
    //     refershObject,
    //     response => {
    //       store.commit("SET_ACCESS_TOKEN", response.access_token);
    //       store.commit("SET_REFRESH_TOKEN", response.refresh_token);
    //       store.commit("SET_TOKEN_EXPIRY_TIME", response.expires_in);
    //       // this.$store.commit("updateisTokenRefreshing", false);
    //     },
    //     errorResponse => {
    //       console.log(errorResponse);
    //       // this.$store.commit("updateisTokenRefreshing", false);
    //       this.$toast.error("Session expired, please kindly login again");
    //       store.dispatch("LogOut");
    //       router.push("/signin");
    //     }
    //   );
    // },
    onNavigationExpand(mini) {
      this.isNavigationExpanded = mini;
    }
  },
  watch: {
    isNavigationExpanded() {},
    // isUserLoggedin(isLogged) {
    //   if (isLogged) {
    //     this.setAuthTimers();
    //   }
    // },
    $route() {
      //scroll to top of the page
      window.scrollTo(0, 0);
      this.isUserLoggedin = store.getters.token;
      //Resetting manually as app.vue just get remounted even on logout
      // if (!this.isUserLoggedin) {
      //   clearInterval(this.refreshInterval);
      //   return;
      // }
    }
  },
  mounted() {
    this.isUserLoggedin = store.getters.token;
  }
};
</script>
<style scoped lang="scss">
@import "./assets/styles/variables.scss";

.v-main-secured-mini {
  padding: 64px 0px 0px 90px !important;
}
.v-main-secured-expanded {
  padding: 64px 0px 0px 300px !important;
}

.arrow-button {
  top: 55px;
  width: 30px !important;
  height: 30px !important;
  background: $neutral-blue-1;
  transition: left 0.1s ease-in-out 0s, visibility 0.1s ease-in-out 0s;
  position: fixed;
  box-shadow: rgb(56 58 60) 0px 0px 0px 1px !important;
  z-index: 10;
}

.arrow-button:hover {
  box-shadow: rgb(214 218 220) 0px 0px 0px 1px !important;
}

.arrow-button-right {
  left: 73px;
}

.arrow-button-left {
  left: 280px;
}
.mdi-chevron-right,
.mdi-chevron-left {
  font-size: 30px !important;
  color: $neutral-white !important;
}
.secured-mini-header {
  padding-left: 34px !important;
  background-color: $neutral-white !important;
  border-bottom: 1px solid rgb(238, 241, 243) !important;
  box-shadow: rgb(0 0 0 / 5%) 0px 2px 10px !important;
}
.secured-expanded-header {
  padding-left: 0;
  background-color: $neutral-white !important;
  border-bottom: 1px solid rgb(238, 241, 243) !important;
  box-shadow: rgb(0 0 0 / 5%) 0px 2px 10px !important;
}
</style>
